import CardMovie from '../../components/CardMovie'

function CreateMovie() {
    return (
        <CardMovie />
    )

}

export default CreateMovie;